import type { PartSvgProps } from './types'

export default function OpticSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 160,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 160 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main tube body */}
      <rect x="40" y="28" width="80" height="24" rx="4"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Objective bell (wider, left) */}
      <path d="M 40 28 L 18 18 L 18 62 L 40 52 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Objective lens ring */}
      <ellipse cx="18" cy="40" rx="6" ry="22" fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Ocular bell (wider, right) */}
      <path d="M 120 28 L 142 20 L 142 60 L 120 52 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Ocular lens ring */}
      <ellipse cx="142" cy="40" rx="5" ry="20" fill="none" stroke={stroke} strokeWidth="1.2" />
      {/* Elevation turret — top center */}
      <rect x="74" y="16" width="12" height="14" rx="2"
            fill={fill} stroke={accent} strokeWidth="1.2" />
      {/* Windage turret — side (right) */}
      <rect x="122" y="34" width="14" height="12" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1" />
      {/* Reticle dot suggestion */}
      <circle cx="80" cy="40" r="3" fill="none" stroke={accent} strokeWidth="1" />
      {/* Mount rings suggestion */}
      <rect x="55" y="50" width="14" height="10" rx="1"
            fill="none" stroke={stroke} strokeWidth="1" />
      <rect x="91" y="50" width="14" height="10" rx="1"
            fill="none" stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
